import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, ApiError } from "../api/client.js";

export function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [status, setStatus] = useState<"verifying" | "success" | "error">("verifying");
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (token === null || token.length === 0) {
      setStatus("error");
      setError("This link is missing its verification token.");
      return;
    }
    let cancelled = false;
    void (async () => {
      try {
        await api.post("/auth/verify-email", null, { token });
        if (!cancelled) {
          setStatus("success");
        }
      } catch (err) {
        if (!cancelled) {
          setStatus("error");
          setError(err instanceof ApiError ? err.message : "Verification failed — please try again.");
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [token]);

  return (
    <div className="login-shell">
      <div className="card login-card">
        <h2>Verify your email</h2>
        {status === "verifying" && <p className="muted">Verifying…</p>}
        {status === "success" && (
          <>
            <div className="success-banner">Your email is verified. Sign in to continue setting up your account.</div>
            <div className="auth-links">
              <Link to="/login">Sign in</Link>
            </div>
          </>
        )}
        {status === "error" && (
          <>
            <div className="error-banner">{error}</div>
            <div className="auth-links">
              <Link to="/resend-verification">Request a new verification link</Link> · <Link to="/login">Back to sign in</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
